// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__eNDF2","projectsContainer":"Projects_projectsContainer__pADCm","projects":"Projects_projects__Oia6D"};